import { render, staticRenderFns } from "./Visits.vue?vue&type=template&id=2ef5796f&scoped=true"
import script from "./Visits.vue?vue&type=script&lang=js"
export * from "./Visits.vue?vue&type=script&lang=js"
import style0 from "./Visits.vue?vue&type=style&index=0&id=2ef5796f&prod&scoped=true&lang=scss"
import style1 from "./Visits.vue?vue&type=style&index=1&id=2ef5796f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef5796f",
  null
  
)

export default component.exports